import { render, staticRenderFns } from "./SeniorsMinistries.vue?vue&type=template&id=06934f3f&"
import script from "./SeniorsMinistries.vue?vue&type=script&lang=js&"
export * from "./SeniorsMinistries.vue?vue&type=script&lang=js&"
import style0 from "./SeniorsMinistries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports